import React from 'react';
import oauth from '~/utils/oauth';
import uuid from 'uuid/v1';
import { useSelector } from 'react-redux';

const ProcessosIframe = (props) => {

    const { className } = props;

    const style = {
        frameborder: "0px",
        width: "100%",
        border: "none",
        display: "block",
        margin: className ? 0 : "10px"
    }
    const { currentFormUrl } = useSelector(state => state.globalReducer);
    const token = oauth.getAccessToken();
    const authtoken = "&Authorization=" + token;
    let url = '/iFlow/' + currentFormUrl + authtoken;
    return (
        currentFormUrl ? <iframe
            key={uuid()}
            id="processos"
            title="processos"
            src={url}
            style={style} />
            :
            <div></div>
    )
}
export default ProcessosIframe